module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1027.a5aa32bf.png";